package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.auth.DeviceDto
import com.evoapps.evoshift.domain.model.Device
import com.evoapps.evoshift.domain.model.DevicePlatform

class DeviceMapper {
    fun toDomain(dto: DeviceDto): Device {
        return Device(
            token = dto.token,
            platform = try { DevicePlatform.valueOf(dto.platform) } catch (e: Exception) { DevicePlatform.ANDROID },
            lastActiveAt = dto.lastActiveAt,
            deviceName = dto.deviceName,
            language = dto.language
        )
    }

    fun toDto(domain: Device): DeviceDto {
        return DeviceDto(
            token = domain.token,
            platform = domain.platform.name,
            lastActiveAt = domain.lastActiveAt,
            deviceName = domain.deviceName,
            language = domain.language
        )
    }
}
